import { httpClient } from '@/services/http/httpClient'
import type { Option } from '@/types/option'

export type ListFiltersRankingResponse = {
  areas: Option[]
  campaigns: Option[]
}

export async function listFiltersRanking(): Promise<ListFiltersRankingResponse> {
  const { data } = await httpClient.get<{
    filters: ListFiltersRankingResponse
  }>('/users/ranking/filters')

  return data.filters
}
